#import "../../../graphql/fragments/inbox-channel-fragment.graphql"

mutation SendTextMessage($input: TextMessageSendInput!) {
    inboxTextMessageSend(input: $input) {
        message {
            id
            status
            content
            isOutbound
            creatorUser {
                id
                name
                initials
                avatarUrl
            }
            scheduledTime
            sentTime
            failedTime
            thread {
                id
                externalChannel {
                    ...InboxChannelFragment
                }
            }
        }
    }
}
